import React, { useContext } from "react";
import { Download } from "lucide-react";
import { useHistory } from "react-router-dom";
import { importOnlineRules } from "../ruleService";
import { PopupContext } from "../../index";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
//import { showSuccessToast, showDangerToast } from "../../validation/ToastContainer";

function ImportOnlineRulesButton({ disabled, handleClose, className = "" }) {

    // const ref = createRef();
    // const {config, setConfig} = useContext(TableContext);

    const history = useHistory();
    const { setPopup } = useContext(PopupContext);

    const onClick = () => {
        setPopup(
            getConfirmPopup('Are you sure?',
                'Import Online Rules',
                () => {
                    handleClose && handleClose();

                    return importOnlineRules()
                        .then(success => {
                        if (success) {
                            //showSuccessToast('Online Rules were imported', 'Import Online Rules');
                            history.go(0);
                        } else {
                            //showDangerToast('There was an error parsing the rules, please review with support', 'Import Online Rules');
                        }
                        });
                }
            )
        );

        // .then(success => success
        // .then(success => success && showSuccessToast('Online Rules Imported', 'Import Online Rules'))

        // const file = event.target.files[0];
        // importXlsxRules(file).then(result => {
        //     event.target.type = '';
        //     event.target.type = 'file';
        //     if (result) {
        //         setConfig({...config, lastUpdated: Date.now()})
        //     }
        // });
    };

    return (
        <>
            <button
                type="button"
                className={`btn modal-v2-btn oct-import-rules-popup__action ${className} ${disabled ? 'disabled' : ''}`}
                onClick={disabled ? null : onClick}
                disabled={disabled}
            >
                <Download className="oct_icon" size={18} />
                <span className="oct-import-rules-popup__action-copy">
                    <span className="oct-import-rules-popup__action-title">Online Import</span>
                    <span className="oct-import-rules-popup__action-subtitle">Fetch rules from the online source</span>
                </span>
            </button>

        </>
    );

}

export default ImportOnlineRulesButton;
